import Datagent                              from 'datagent';
import { respondData, requestHandle, isDef, flat} from '../utils';
import {defaults}                            from 'datagent/src/utils';
import { getURL } from 'datagent/src/utils';
import Schema from 'datagent/src/classes/Schema.class';

const {filter, format, getField, awaitTo} = Datagent.Hooks;
const isNew = data => !isDef(data.id) || !data.id

const name  = 'carbonCompanyVote';
const Model = Datagent.Model({
    name,
    fields : {
        'id'                : {type: Number, default: null},
        'stockCode': {type: String, default: ''}, //股票代码
        'year' : {type: String, default: ''}, // 年份
        'link'  : {type: String, default: ''}, //链接
        'reason'   : {type: String, default: ''}, // 原因
    },
    methods: {
    },
    hooks  : {
        fetch              : {after: [respondData(), requestHandle(), getField('data', flat(['companyInfo']))]},
        find               : {after: [respondData(), requestHandle()]},
        save               : { before: [filter(['id','stockCode', 'year','link','reason'])], after: [respondData(), requestHandle()] },
        destroy : {after: [respondData(), requestHandle()]}
    }
});

Model.ModelName   = name;
Model.validation = function () {
    return {
        year: [
            { required: true, type: 'number', message: '请选择项目年', trigger: 'change' }
        ],
        stockCode: [
            { required: true, type: 'string', message: '请选择公司', trigger: 'change' }
        ],
    }
};
export default Model;
